export default "__VITE_ASSET__BUoEjKmx__"